import {
  AirportItem,
  CountryItem,
  PageResult,
  Portal,
  TideClientConfig,
} from "../types";
import { LocationItem } from "../types/offer/location-item";
import { get } from "./common-client";

const ENDPOINT = "/api/web/search";
const ENDPOINT_COUNTRIES = `${ENDPOINT}/countries`;
const ENDPOINT_REGIONS = `${ENDPOINT}/regions`;
const ENDPOINT_OORDS = `${ENDPOINT}/oords`;
const ENDPOINT_LOCATIONS = `${ENDPOINT}/locations`;
const ENDPOINT_PORTAL = (portalId: number) => `${ENDPOINT}/portal/${portalId}`;
const ENDPOINT_AIRPORT = "/api/web/entity/airport";

/**
 * api/search/countries
 * Gets all Countries
 * @param config
 * @param signal
 * @returns OK if succeeded.
 */
export const getCountries = (
  config: TideClientConfig,
  signal?: AbortSignal
): Promise<PageResult<CountryItem>> => {
  const url = `${config.host}${ENDPOINT_COUNTRIES}`;
  const apiKey = config.apiKey;

  return get(url, apiKey, config.token, signal, true);
};

export const searchCountries = (
  config: TideClientConfig,
  searchTerm: string,
  signal?: AbortSignal
): Promise<PageResult<CountryItem>> => {
  const apiKey = config.apiKey;

  const safeSearch = searchTerm.replace(/'/g, "''");
  const filter = `$skip=0&$top=20&$orderby=name%20asc&$filter=contains(name,'${safeSearch.toLowerCase()}')`;

  const url = `${config.host}${ENDPOINT_COUNTRIES}?${filter}`;

  return get(url, apiKey, config.token, signal, true);
};

export const searchRegions = (
  config: TideClientConfig,
  searchTerm: string,
  signal?: AbortSignal
): Promise<PageResult<LocationItem>> => {
  const apiKey = config.apiKey;

  const safeSearch = searchTerm.replace(/'/g, "''");
  const filter = `$skip=0&$top=20&$orderby=name%20asc&$filter=contains(name,'${safeSearch.toLowerCase()}')`;

  const url = `${config.host}${ENDPOINT_REGIONS}?${filter}`;

  return get(url, apiKey, config.token, signal, true);
};

export const searchOords = (
  config: TideClientConfig,
  searchTerm: string,
  signal?: AbortSignal
): Promise<PageResult<LocationItem>> => {
  const apiKey = config.apiKey;

  const safeSearch = searchTerm.replace(/'/g, "''");
  const filter = `$skip=0&$top=20&$orderby=name%20asc&$filter=contains(name,'${safeSearch.toLowerCase()}')`;

  const url = `${config.host}${ENDPOINT_OORDS}?${filter}`;

  return get(url, apiKey, config.token, signal, true);
};

export const searchLocations = (
  config: TideClientConfig,
  searchTerm: string,
  signal?: AbortSignal
): Promise<PageResult<LocationItem>> => {
  const apiKey = config.apiKey;

  const safeSearch = searchTerm.replace(/'/g, "''");
  const filter = `$skip=0&$top=20&$orderby=name%20asc&$filter=contains(name,'${safeSearch.toLowerCase()}')`;

  const url = `${config.host}${ENDPOINT_LOCATIONS}?${filter}`;

  return get(url, apiKey, config.token, signal, true);
};

export const getPortal = (
  config: TideClientConfig,
  portalId: number,
  signal?: AbortSignal
): Promise<Portal> => {
  const url = `${config.host}${ENDPOINT_PORTAL(portalId)}`;
  const apiKey = config.apiKey;

  return get(url, apiKey, config.token, signal, true);
};

export const getAirports = (
  config: TideClientConfig,
  signal?: AbortSignal
): Promise<AirportItem[]> => {
  const url = `${config.host}${ENDPOINT_AIRPORT}`;
  const apiKey = config.apiKey;

  return get(url, apiKey, config.token, signal, true);
};
